import { DoorDashLogoMark, CaviarLogoMark } from './LogoMark.js';
import { DoorDashLogoText, CaviarLogoText } from './LogoText.js';
import { TextColor, ThemingContext, InlineChildren, InlineChildrenAlignment } from '@doordash/design-language';
import { LogoColor, DefaultColors, DefaultLogoSize, InlineChildrenSizeForSize, TypeSizesForSize, TextColorMap } from './constants.js';
import { LogoTextContainer, TypeWrapper, Type } from './styles.js';
import { LogoSize, LogoType, LogoBrand } from './types.js';
import React from 'react';
import get from 'lodash.get';

var Logo = function Logo(_ref) {
  var text = _ref.text,
      _ref$textColor = _ref.textColor,
      textColor = _ref$textColor === void 0 ? TextColor.TextTertiary : _ref$textColor,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? LogoSize.Base : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? LogoColor.Default : _ref$color,
      brand = _ref.brand,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? LogoType.Logo : _ref$type;
  var renderedBrand = LogoBrand.DoorDash;
  var theme = React.useContext(ThemingContext);

  if (typeof brand === 'undefined') {
    renderedBrand = get(theme, 'Logo.Brand', LogoBrand.DoorDash);
  } else {
    renderedBrand = brand;
  }

  var renderedColor;

  if (color === LogoColor.Default) {
    renderedColor = DefaultColors[renderedBrand];
  } else {
    renderedColor = color;
  }

  var renderedSize = DefaultLogoSize[renderedBrand][size];

  switch (renderedBrand) {
    case LogoBrand.Caviar:
      return /*#__PURE__*/React.createElement(InlineChildren, {
        alignItems: type === LogoType.Logo ? InlineChildrenAlignment.Baseline : InlineChildrenAlignment.Center,
        size: InlineChildrenSizeForSize[size]
      }, type === LogoType.Logo ? /*#__PURE__*/React.createElement(LogoTextContainer, null, /*#__PURE__*/React.createElement(CaviarLogoText, {
        size: renderedSize,
        color: renderedColor
      })) : /*#__PURE__*/React.createElement(CaviarLogoMark, {
        size: renderedSize,
        color: renderedColor
      }), text && /*#__PURE__*/React.createElement(TypeWrapper, {
        height: renderedSize
      }, /*#__PURE__*/React.createElement(Type, {
        brand: renderedBrand,
        size: TypeSizesForSize[renderedBrand][size],
        color: textColor || TextColor[TextColorMap[renderedColor]]
      }, text)));

    case LogoBrand.DoorDash:
    default:
      return /*#__PURE__*/React.createElement(InlineChildren, {
        alignItems: InlineChildrenAlignment.Center,
        size: InlineChildrenSizeForSize[size]
      }, /*#__PURE__*/React.createElement(DoorDashLogoMark, {
        size: renderedSize,
        color: renderedColor
      }), type === LogoType.Logo && /*#__PURE__*/React.createElement(LogoTextContainer, null, /*#__PURE__*/React.createElement(DoorDashLogoText, {
        size: renderedSize,
        color: renderedColor
      })), text && /*#__PURE__*/React.createElement(TypeWrapper, {
        height: renderedSize
      }, /*#__PURE__*/React.createElement(Type, {
        brand: renderedBrand,
        size: TypeSizesForSize[renderedBrand][size],
        color: textColor || TextColor[TextColorMap[renderedColor]]
      }, text)));
  }
};

Logo.Colors = LogoColor;
Logo.Sizes = LogoSize;
Logo.Brands = LogoBrand;
Logo.Types = LogoType;

export { Logo as default };
